import { useEffect, useState } from 'react';
import {
  isPermissionLoading,
  isPermissionReady,
  subscribePermissionChange,
} from '@sg/_config/permissionStore';

export const usePermissionReady = () => {
  const [state, setState] = useState({
    ready: isPermissionReady(),
    loading: isPermissionLoading(),
  });

  useEffect(() => subscribePermissionChange(() => {
    setState({
      ready: isPermissionReady(),
      loading: isPermissionLoading(),
    });
  }), []);

  return state;
};
